import { ContractError } from '@root/@types/types';

export const contractErrorMessages = {
  [ContractError.InvalidForm]:
    'Some required form data is missing. Please ensure all mandatory fields are completed before proceeding.',
  [ContractError.MissingDatapoints]: 'The contract has missing data points.',
  [ContractError.NoMaterialChanges]: 'This endorsement has no material changes against the contract.',
};

export const contractErrorValidationSuccessMessages = {
  [ContractError.InvalidForm]: 'All mandatory form data is complete.',
};
